export default __webpack_public_path__ + "static/media/health.ca22b6bd.svg";